import { useRoute, useRouter } from 'vue-router'
import { ref } from 'vue'
import { scrollToTop } from '~/utils'
import type { NavigationItem } from '~/utils/interface'
import { MENU_HEDER_SLUGS } from '~/configs/page-url'
import { listCategory } from '~/resources/news'
import { SLUG_NEWS } from '~/constants'
import { useModal } from '~/composables/common/use-modal'

export function useNavigationBar() {
  const route = useRoute()
  const router = useRouter()
  const userMenuRef = ref()
  const { openModal } = useModal()
  const isDropDownUser = ref(false)
  const isShowWallet = ref(false)
  function toggleDropDownUser(): void {
    isDropDownUser.value = !isDropDownUser.value
    isShowWallet.value = false
  }

  function clickLogo(): void {
    void router.push('/')
    scrollToTop()
  }

  function activeItemMenu(link: string): boolean {
    if (MENU_HEDER_SLUGS.includes(route.fullPath)) {
      return route.fullPath === link
    }
    if (link === `/${SLUG_NEWS.PAGE}`) {
      const newsSlugCurrent = route.params?.slug?.toString()
      const newsCategory = listCategory.find(item => item.slug === newsSlugCurrent)
      if (newsCategory ?? newsSlugCurrent?.includes('.html')) {
        return true
      }
    }
    return route.path === link
  }

  function redirectMenu(menu: NavigationItem): void {
    let newTab: Window | null
    isDropDownUser.value = false
    if (menu.modalId) {
      openModal(menu.modalId, menu.modalTab, true)
    }
    if (menu.link) {
      void router.push(menu.link)
    }
    if (menu.isNewTab) {
      newTab = window.open('', '_blank')
      if (newTab) {
        newTab.location.href = menu.link
      }
    }
    isDropDownUser.value = false
    isShowWallet.value = false
  }

  function mouseOverDropDown(): void {
    isDropDownUser.value = false
    isShowWallet.value = true
  }

  return {
    userMenuRef,
    isDropDownUser,
    toggleDropDownUser,
    activeItemMenu,
    redirectMenu,
    clickLogo,
    mouseOverDropDown,
    isShowWallet,
    route
  }
}
